import CloseIcon from '@/assets/images/icons/x-circle.svg';
import React from 'react';
import { Dimensions } from 'react-native';
import { Dialog, VisuallyHidden, XStack, YStack } from 'tamagui';

interface ModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  children?: React.ReactNode;
}

export function Modal({
  open,
  onOpenChange,
  children
}: ModalProps) {
  // Calculate dimensions once, not in render
  const screenHeight = (typeof window !== 'undefined' && window.innerHeight) 
    ? window.innerHeight 
    : Dimensions.get('window').height;
  
  const popupHeight = Math.min(0.75 * screenHeight, 700)
  const calculatedWidth = Math.min(650, popupHeight * 0.9)
  
  const dimensions = {
    maxWidth: calculatedWidth,
    width: calculatedWidth,
    maxHeight: popupHeight,
    height: popupHeight,
  }

  return (
    <Dialog modal open={open} onOpenChange={onOpenChange}>
      <Dialog.Portal zIndex={100}>
        <Dialog.Overlay 
          key="overlay"
          animation="quick"
          opacity={0.6}
          backgroundColor="rgba(0, 0, 0, 0.6)"
          enterStyle={{ opacity: 0 }}
          exitStyle={{ opacity: 0 }}
          onPress={() => onOpenChange(false)}
          zIndex={100}
        />
          <Dialog.Content
            // bordered
            elevate
            key="content"
            animateOnly={['transform', 'opacity']}
            animation={[
              'quick',
              {
                opacity: {
                  overshootClamping: true,
                },
              },
            ]}
            enterStyle={{ x: 0, y: -20, opacity: 0, scale: 0.9 }}
            exitStyle={{ x: 0, y: 10, opacity: 0, scale: 0.95 }}
            gap="$4"
            padding="$0"
            backgroundColor="white"
            borderRadius="$6"
            borderTopLeftRadius="$6"
            borderTopRightRadius="$6"
            borderBottomLeftRadius="$6"
            borderBottomRightRadius="$6"
            maxWidth={dimensions.maxWidth}
            width={dimensions.width}
            maxHeight={dimensions.maxHeight}
            height={dimensions.height}
            onPress={(e) => e.stopPropagation()}
            zIndex={100}
          >
          <VisuallyHidden>
            <Dialog.Title>Lesson Completed</Dialog.Title>
          </VisuallyHidden>
          <YStack flex={1} overflow="hidden" position="relative" borderRadius="$6">
            <XStack
              position="absolute"
              top="$3"
              right="$3"
              zIndex={10}
            >
              <CloseIcon 
                width={40} 
                height={40} 
                color="#666"
                onPress={() => onOpenChange(false)}
                style={{ cursor: 'pointer' }}
              />
            </XStack>
            
            {children}
          </YStack>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog>
  );
}
